import { Icon } from "@chakra-ui/react";
import {
  MdPerson,
  MdManageAccounts,
  MdAttachMoney,
  MdPending,
  MdPhotoLibrary,
  MdAddCircleOutline,
} from "react-icons/md";
import { FaUserCheck } from "react-icons/fa6";
import React from "react";

// Auth Imports
import SignIn from "./views/auth/signIn";
import PayoutCheck from "@/src/views/admin/payoutCheck";
import User from "@/src/views/admin/user";
import AccountManagers from "@/src/views/admin/accountManagers";
import CoinLogs from "@/src/views/admin/coinLogs";
import BulkAddCoinsPage from "@/src/views/admin/bulkAddCoins";
import OnHoldPayoutsPage from "@/src/views/admin/onHoldPayouts";
import SocialMediaPostsPage from "@/src/views/admin/socialMediaPosts";

export interface RoutesType {
  name: string;
  layout: string;
  path: string;
  icon?: JSX.Element;
  component: React.ComponentType<any>;
}

const routes: RoutesType[] = [
  {
    name: "User",
    layout: "/",
    path: "/users",
    icon: (
      <Icon
        as={MdManageAccounts}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: User,
  },
  {
    name: "User Check",
    layout: "/",
    path: "/user-check",
    icon: (
      <Icon
        as={FaUserCheck}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: PayoutCheck,
  },
  {
    name: "Account Managers",
    layout: "/",
    path: "/account-managers",
    icon: (
      <Icon
        as={MdManageAccounts}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: AccountManagers,
  },
  {
    name: "Coin Logs",
    layout: "/",
    path: "/coin-logs",
    icon: (
      <Icon
        as={MdAttachMoney}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: CoinLogs,
  },
  {
    name: "Bulk Add Coins",
    layout: "/",
    path: "/bulk-add-coins",
    icon: (
      <Icon
        as={MdAddCircleOutline}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: BulkAddCoinsPage,
  },
  {
    name: "On Hold Payouts",
    layout: "/",
    path: "/on-hold-payouts",
    icon: (
      <Icon
        as={MdPending}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: OnHoldPayoutsPage,
  },
  {
    name: "Social Media Posts",
    layout: "/",
    path: "/social-media-posts",
    icon: (
      <Icon
        as={MdPhotoLibrary}
        width="20px"
        height="20px"
        marginTop={0.5}
        color="inherit"
      />
    ),
    component: SocialMediaPostsPage,
  },
  {
    name: "Login",
    layout: "/auth",
    path: "/auth/login",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: SignIn,
  },
];

export default routes;
